import { HotelResultsLayout } from '@shared/models/hotel-results-layout.model';

export const GET_HOTEL_RESULTS_LAYOUT = '[Hotel results] Get hotel layout type';
export const GET_HOTEL_RESULTS_LAYOUT_SUCCESS = '[Hotel results] Get hotel layout type success';
export const SET_HOTEL_RESULTS_LAYOUT = '[Hotel results] Set hotel layout type';
export const SET_HOTEL_RESULTS_LAYOUT_SUCCESS = '[Hotel results] Set hotel layout type success';

export const RESTORE_HOTEL_RESULTS_LAYOUT = '[Hotel results] Restore hotel results layout';
export const RESTORE_HOTEL_RESULTS_LAYOUT_SUCCESS = '[Hotel results] Restore hotel results layout success';

export class GetHotelLayout {
  readonly type = GET_HOTEL_RESULTS_LAYOUT;
}

export class GetHotelLayoutSuccess {
  readonly type = GET_HOTEL_RESULTS_LAYOUT_SUCCESS;
  constructor(public payload: string) {}
}

export class SetHotelLayout {
  readonly type = SET_HOTEL_RESULTS_LAYOUT;
}

export class SetHotelLayoutSuccess {
  readonly type = SET_HOTEL_RESULTS_LAYOUT_SUCCESS;
  constructor(public payload: string) {}
}

export class RestoreHotelResultsLayout {
  readonly type = RESTORE_HOTEL_RESULTS_LAYOUT;
}

export class RestoreHotelResultsLayoutSuccess {
  readonly type = RESTORE_HOTEL_RESULTS_LAYOUT_SUCCESS;
  constructor(public payload: HotelResultsLayout) {}
}

export type HotelActions =
  | GetHotelLayout
  | GetHotelLayoutSuccess
  | SetHotelLayout
  | SetHotelLayoutSuccess
  | RestoreHotelResultsLayout
  | RestoreHotelResultsLayoutSuccess;
